<template>
<el-container style="width: 100%; height: 100vh">
  <img src="/back.jpeg" style="width: 50%; height: 100vh; z-index:1;opacity: 0.8"/>
  <div style="flex-grow: 1.0; height: 100%" class="row">
  <div style="border-radius:20px;background-color:white;width: 400px; height: auto;padding:20px; border: 1px solid #E4E7ED; box-sizing: border-box">
    <div class="row" style="width: 100%; margin-top: 0px;font-weight: normal; font-size: 26px; font-family: 'Microsoft YaHei'">
      欢迎登陆 <div style="font-weight: bolder; color:darkslateblue; font-size: 26px;margin-left: 10px">噼里啪啦</div>
    </div>
    <el-input
        v-model="user_name"
        class="info"
        @input="handleUserName"
        placeholder="请输入用户名"
    />
    <el-input
        v-model="user_secret"
        class="info"
        @input="handleUserSecret"
        type="password"
        placeholder="请输入密码"
        @keydown.enter="doEnroll"
        show-password
    />
    <el-button @click="doEnroll"
        style="background-color: #6467f0; color: white; border: none; width: 100%; margin-left: 0%;margin-top: 30px; height:40px; border-radius: 8px">
      登陆/注册
    </el-button>
  </div>
  </div>
</el-container>
</template>

<script setup>
import {ref} from "vue";
import router from "@/router";
import {useStore} from "vuex";
// import axios from 'axios';

const store = useStore();

const user_name = ref("");
const user_secret = ref("");

const handleUserName = () => {
  // 过滤掉不允许的字符
  user_name.value = user_name.value.replace(/[^a-zA-Z0-9_.]/g, '');

}

const handleUserSecret = () => {
  // 过滤掉不允许的字符
  user_secret.value = user_secret.value.replace(/[^a-zA-Z0-9_.]/g, '');
  // store.state.user.usersecret = user_secret.value;
}

const doEnroll = async () =>{
  // user_name.value = "";
  // user_secret.value = "";
    try {
      // console.log(store);
      console.log( user_name.value,user_secret.value)
      await store.dispatch('login', { username: user_name.value, password: user_secret.value });

      store.username = '';
      console.log(store.getters.isLogined);
      router.back();
      // router.push('/beyond'); // 登录成功后跳转到仪表盘
    } catch (error) {
      console.error('登录失败:', error);
    }
  // router.back();
}

</script>

<style scoped>

.item{
  width: 50%;
  text-align: center;
  padding: 5px;
  box-sizing: border-box;
}

.item:hover{
  border: 1px solid #6467f0;
}

.info{
  width: 100%;
  margin-left: 0%;
  margin-top: 30px;
  height:40px;
  border-radius: 8px;
  text-indent: 10px;

  outline: none;
}

.info:hover{
  outline: none;
  --el-input-focus-border-color: #6467F0;
  --el-input-hover-border-color: #6467F0;
}

</style>